import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { message } from 'antd';
import axios from 'axios';
import LmHeader from '../components/LmHeader.jsx';
import LmFooter from '../components/LmFooter.jsx';

const ConfirmDeletion = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [status, setStatus] = useState(token ? 'loading' : 'missing');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        await axios.post('https://limitverify.ru:5000/api/client/delete-account/confirm-token', { token });
        if (!cancelled) {
          setStatus('ok');
          message.success('Удаление подтверждено');
        }
      } catch (err) {
        if (!cancelled) {
          setStatus('error');
          setError(err.response?.data?.error || 'Не удалось подтвердить');
        }
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="lm-page">
      <LmHeader actions={[{ label: 'Вход', onClick: () => navigate('/enter') }]} />
      <main className="lm-content lm-content--center">
        <div className="lm-auth">
          <div className="lm-auth__head">
            <h1 className="lm-auth__title">
              {status === 'ok' && 'Удаление подтверждено'}
              {status === 'loading' && 'Подтверждение...'}
              {status === 'missing' && 'Ссылка недействительна'}
              {status === 'error' && 'Ошибка подтверждения'}
            </h1>
            <span className="lm-auth__sub">
              {status === 'ok' && 'Администратор завершит обработку заявки. При необходимости с вами свяжутся.'}
              {status === 'loading' && 'Проверяем токен из письма...'}
              {status === 'missing' && 'В ссылке нет токена подтверждения.'}
              {status === 'error' && error}
            </span>
          </div>
          <button type="button" className="lm-btn lm-btn--block" onClick={() => navigate('/enter')}>
            Войти в кабинет
          </button>
        </div>
      </main>
      <LmFooter />
    </div>
  );
};

export default ConfirmDeletion;
